export enum FastRepliesElementType {
    Popover = "popover",
    ContextMenu = "contextMenu"
}

export interface FastRepliesOpenedElement {
    articleId: string
    elementType: FastRepliesElementType
}
